import React, { useCallback, useEffect, useState } from 'react'
import styles from './styles.module.scss'
import cn from 'classnames'
import { ReactComponent as CopiedIcon } from '../../../../../assets/icons/copied_icon.svg'
import { ReactComponent as GiftIcon } from './icons/gift.svg'
import { ReactComponent as LinkIcons } from '../../../../../assets/icons/link_icons.svg'
import { setReferralStart } from '../../../../../api/postApi'
import { useDispatch, useSelector } from 'react-redux'

function ReferralBanner(props) {
  const [wasCopied, setWasCopied] = useState(false)
  const [createdLink, setCreatedLink] = useState(null)

  const dispatch = useDispatch()
  const referralData = useSelector(({ billing }) => billing.referralData)

  const { referral_link } = referralData

  const handleCopyLink = async () => {
    referral_link || createdLink
      ? await (async () => {
        setWasCopied(true)
        await navigator.clipboard.writeText(referral_link || createdLink)
        setTimeout(() => setWasCopied(false), 2000)
      })()
      : await (async () => {
        const { referral_link } = await setReferralStart()
        setCreatedLink(referral_link)
        setWasCopied(true)
        await navigator.clipboard.writeText(referral_link || createdLink)
        setTimeout(() => setWasCopied(false), 2000)
      })()
  }

  return (
    <div className={styles.referralBanner}>
      <div className={styles.referralBannerBackGround}>
        <div className={styles.wrapper}>
          <strong>Share your </strong>
          <h2>Referral link</h2>
          <strong>and earn bonuses</strong>
          <br />
          <p>for every seafarer who joins our Telegram channel or register on the NextShip platform</p>
          <button
            className={cn(
              styles.link_button,
              [wasCopied && styles.link_button_success_copied],
              [!referral_link && styles.link_button_create]
            )}
            onClick={handleCopyLink}
          >
            {wasCopied ? (
              <>
                Link successfully copied <CopiedIcon />
              </>
            ) : (
              <>
                Copy link
                {!referral_link && !createdLink && <LinkIcons />}
              </>
            )}{' '}
          </button>
        </div>
        {!wasCopied && <GiftIcon className={styles.giftIcon} />}
      </div>
    </div>
  )
}

export default ReferralBanner
